import Logger from "../../../clients/logger";
import ConfigClient from "../../../clients/configClient";
import { BootTaskCallbackInterface } from "../types";
import { System } from "../../../common/system";

/**
 * Boot task that hides the splash screen if required.
 * @private
 */
export class HideSplashScreenTask {
	public start(doneCallback: BootTaskCallbackInterface) {
		Logger.system.log("Hide Splash Screen Task Started.");
		ConfigClient.getValue("splashScreenTimeout", (err, splashScreenTimeout) => {
			System.hideSplashScreen();
			doneCallback("hideSplashScreenTask", "bootTasks", "completed");
		});
	}
}
